import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import inventoryHelpers from '../../helpers/inventory';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

function InventorySearch(props) {

    const [sku, setSku] = useState('');
    const [availableInventory, setAvailableInventory] = useState('');

    useEffect(() => {
    },[] )

    let cardFont = 25;


    const searchInventory = async () => {
        props.setLoading(true);
        try {
            props.setLoading(true);
            const response = await inventoryHelpers.searchInventory(props.company, props.token, sku);
            setAvailableInventory(response.data);
        }
        catch(err) {
            console.log(err);
        }
        props.setLoading(false);
    }



return (
    <Box
        display="flex"
        flexDirection="column"
        className={props.isMobile ? 'mobile-top' : 'desktop-top'}
    >
    <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
        <h1>Inventory Search</h1> 
        <Box
        className={props.isMobile ? 'mobile-box' : 'desktop-box'}
        sx={{ mb: 2 }}
        >
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems="center"
            sx={{ mt: { xs: 4, sm: 8 } }} 
        >
            <TextField
                name="sku"
                value={sku}
                label="Inventory to Search"
                onChange={(e) => setSku(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && searchInventory()}
                sx={{ width: { xs: '100%', sm: 400 } }}
            />
            <Button 
                onClick = {searchInventory} 
                endIcon = {<SearchIcon />}
                size = 'large'
                sx = {{mt: '10px', fontWeight: 'bold', color: '#84B375'}}>
            Search
            </Button>
        </Stack>
        <Box sx={{ mt: 4, width: { xs: '100%', sm: 400 } }}>
                <Card sx={{ width: '100%' }}>
                <CardContent>
                    <Typography sx={{ fontSize: cardFont }} color="text.secondary" gutterBottom>
                    Available Inventory: {availableInventory}
                    </Typography>
                </CardContent>
                </Card>
            </Box>
            </Box>
        </Box>
        </Box>
    );
}


export default InventorySearch;